var React = require('react');

function FrontendDropdownMenuFunnels (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#000000","d":"M16 3.5c0-1.933-3.582-3.5-8-3.5s-8 1.567-8 3.5c0 0.615 0.363 1.193 1 1.696h-0l5 4.57v5.234c0 0.552 0.895 1 2 1s2-0.448 2-1v-5.234l5-4.57c0.637-0.502 1-1.080 1-1.696zM14.38 4.442l-5.38 4.883v5.472c-0.159 0.088-0.505 0.203-1 0.203s-0.841-0.115-1-0.203v-5.472l-5.38-4.883c-0.231-0.182-0.62-0.575-0.62-0.942 0-0.204 0.117-0.429 0.348-0.667 0.307-0.318 0.79-0.626 1.396-0.891 0.665-0.291 1.447-0.552 2.324-0.714 0.926-0.171 1.913-0.29 2.932-0.29s2.006 0.118 2.932 0.29c0.877 0.162 1.659 0.423 2.324 0.714 0.606 0.265 1.089 0.573 1.396 0.891 0.231 0.239 0.348 0.463 0.348 0.667 0 0.367-0.388 0.759-0.62 0.942zM3 3.633c0-0.755 2.239-1.367 5-1.367s5 0.612 5 1.367c0 0.755-2.239 1.367-5 1.367s-5-0.612-5-1.367z"}));
}

FrontendDropdownMenuFunnels.displayName = "FrontendDropdownMenuFunnels";

FrontendDropdownMenuFunnels.defaultProps = {"version":"1.1","width":"100%","height":"100%","viewBox":"0 0 16 16"};

module.exports = FrontendDropdownMenuFunnels;

FrontendDropdownMenuFunnels.default = FrontendDropdownMenuFunnels;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js!./src/svg/menu-icons/frontend-dropdown-menu-funnels.svg
// module id = 1005
// module chunks = 0